import React, { useMemo } from 'react';
import { Card, Typography, Tabs, Button } from 'antd';
import {
  SettingOutlined,
  UserOutlined,
  LinkOutlined,
  MailOutlined,
  ToolOutlined,
  ArrowLeftOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useResponsive } from '../hooks/useResponsive';
import { useAppSelector } from '../hooks/redux';
import { isSupportUser } from '../utils/roleHelpers';
import ConfiguracionFiscalTab from '../components/facturacion/ConfiguracionFiscalTab';
import ClientesFiscalesManager from '../components/facturacion/ClientesFiscalesManager';
import ProductoFacturacionMapper from '../components/facturacion/ProductoFacturacionMapper';
import EmailConfigTab from '../components/facturacion/EmailConfigTab';
import SifeiEnvironmentTab from '../components/facturacion/SifeiEnvironmentTab';

const { Title, Text } = Typography;

const FacturacionSettings: React.FC = () => {
  const { isMobile } = useResponsive();
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.auth);
  const isSupport = isSupportUser(user?.email);

  const tabItems = useMemo(() => [
    {
      key: 'config',
      label: (
        <span>
          <SettingOutlined />
          {isMobile ? ' Config' : ' Configuración Fiscal'}
        </span>
      ),
      children: <ConfiguracionFiscalTab />,
    },
    {
      key: 'clientes',
      label: (
        <span>
          <UserOutlined />
          {isMobile ? ' Clientes' : ' Clientes Fiscales'}
        </span>
      ),
      children: <ClientesFiscalesManager />,
    },
    {
      key: 'mapeo',
      label: (
        <span>
          <LinkOutlined />
          {isMobile ? ' Mapeo' : ' Mapeo de Productos'}
        </span>
      ),
      children: <ProductoFacturacionMapper />,
    },
    {
      key: 'email',
      label: (
        <span>
          <MailOutlined />
          {isMobile ? ' Email' : ' Correo Electrónico'}
        </span>
      ),
      children: <EmailConfigTab />,
    },
    // Tab de Soporte - solo visible para usuarios de soporte (@massresto.com)
    ...(isSupport ? [{
      key: 'soporte',
      label: (
        <span style={{ color: '#ff4d4f' }}>
          <ToolOutlined />
          {isMobile ? ' Soporte' : ' Soporte (SIFEI)'}
        </span>
      ),
      children: <SifeiEnvironmentTab />,
    }] : []),
  ], [isMobile, isSupport]);

  return (
    <div>
      <Button
        type="link"
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate('/configuracion')}
        style={{ padding: 0, marginBottom: 16 }}
      >
        Volver a Configuración
      </Button>
      <div style={{ marginBottom: isMobile ? 12 : 24 }}>
        <Title level={isMobile ? 4 : 2}>
          <SettingOutlined /> {isMobile ? 'Facturación' : 'Configuración de Facturación'}
        </Title>
        {!isMobile && (
          <Text type="secondary">
            Configure los parámetros fiscales, clientes y mapeo de productos para facturación electrónica
          </Text>
        )}
      </div>

      <Card bodyStyle={{ padding: isMobile ? 12 : 24 }}>
        <Tabs
          defaultActiveKey="config"
          items={tabItems}
          size={isMobile ? 'small' : 'middle'}
        />
      </Card>
    </div>
  );
};

export default FacturacionSettings;
